// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
  background-color: #fff;
  border-bottom: 2px solid #ffe6c7;
  padding: 0.8rem 0;
}

.navbar .container-fluid {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.container-fluid button {
  border: none;
}

.container-fluid .navbar-nav {
  gap: 0.9rem;
}

.navbar-collapse {
  flex-grow: 0;
  display: none;
}

.navbar-collapse.active {
  display: block;
}

.navbar-toggler {
  cursor: pointer;
}

.nav-link {
  font-weight: 400;
  font-size: 0.9rem;
  color: #000;
  transition: color 0.25s ease;
}

.nav-link:hover,
.nav-link.active,
.nav-link[aria-current="page"] {
  color: #ffa559 !important;
}

@media (min-width: 600px) and (max-width: 1080px) {
  .navbar {
    padding: 0.8rem;
  }
  .navbar .container-fluid .navbar-collapse {
    padding: 1rem 0rem 0rem 0rem;
  }
  .container-fluid .navbar-collapse .navbar-nav {
    gap: 1rem;
  }
}

@media (max-width: 890px) {
  .navbar .container-fluid {
    justify-content: space-between;
    padding: 0 2.5em;
  }
}

@media (max-width: 580px) {
  .navbar .container-fluid {
    justify-content: space-between;
    padding: 0 2em;
  }

  .navbar .container-fluid .navbar-collapse {
    padding: 1rem 0rem 0rem 0rem;
  }
  .container-fluid .navbar-collapse .navbar-nav {
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,cAAc;EAChB;;EAEA;IACE,4BAA4B;EAC9B;EACA;IACE,SAAS;EACX;AACF","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 9999;\n  background-color: #fff;\n  border-bottom: 2px solid #ffe6c7;\n  padding: 0.8rem 0;\n}\n\n.navbar .container-fluid {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.container-fluid button {\n  border: none;\n}\n\n.container-fluid .navbar-nav {\n  gap: 0.9rem;\n}\n\n.navbar-collapse {\n  flex-grow: 0;\n  display: none;\n}\n\n.navbar-collapse.active {\n  display: block;\n}\n\n.navbar-toggler {\n  cursor: pointer;\n}\n\n.nav-link {\n  font-weight: 400;\n  font-size: 0.9rem;\n  color: #000;\n  transition: color 0.25s ease;\n}\n\n.nav-link:hover,\n.nav-link.active,\n.nav-link[aria-current=\"page\"] {\n  color: #ffa559 !important;\n}\n\n@media (min-width: 600px) and (max-width: 1080px) {\n  .navbar {\n    padding: 0.8rem;\n  }\n  .navbar .container-fluid .navbar-collapse {\n    padding: 1rem 0rem 0rem 0rem;\n  }\n  .container-fluid .navbar-collapse .navbar-nav {\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 890px) {\n  .navbar .container-fluid {\n    justify-content: space-between;\n    padding: 0 2.5em;\n  }\n}\n\n@media (max-width: 580px) {\n  .navbar .container-fluid {\n    justify-content: space-between;\n    padding: 0 2em;\n  }\n\n  .navbar .container-fluid .navbar-collapse {\n    padding: 1rem 0rem 0rem 0rem;\n  }\n  .container-fluid .navbar-collapse .navbar-nav {\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
